// @flow
import isArray from 'lodash/isArray';

export default function normalizedSource(sources: Array<SourceAPI>): Array<Source> {
  if (!isArray(sources)) {
    return [];
  }

  return sources.map(source => ({ name: source.name, image: source.image }));
}



// WEBPACK FOOTER //
// ./app/normalize/source.js